@let q = quality();
@let h = history();
@let problems = problemCount();
@let pps = packetsPerSec();
<div class="summary">
  <fa-duotone-icon class="summary-icon" [class]="q.iconClass" [icon]="q.icon"></fa-duotone-icon>
  <div>
    <div class="summary-quality">
      {{ q.label | translate }}
      @if (problems) {
        · {{ 'Streams with problems: [count]' | translate: { count: problems } }}
      }
    </div>
    <div class="summary-sub">
      {{ 'Ping' | translate }} {{ rtt() }} ms · {{ 'Loss' | translate }} {{ loss().toFixed(1) }} %
    </div>
  </div>
</div>

<div class="graphs">
  <andor-stats-graph
    [label]="'Ping (ms)' | translate"
    [series]="h.rtt"
    [minSpan]="10"
    [tone]="rttTone()"></andor-stats-graph>
  <andor-stats-graph
    [label]="'Loss (%)' | translate"
    [series]="h.loss"
    [minSpan]="1"
    [digits]="1"
    [tone]="lossTone()"></andor-stats-graph>
  <andor-stats-graph
    [label]="'Download (Kbps)' | translate"
    [series]="h.downKbps"
    [minSpan]="64"></andor-stats-graph>
  <andor-stats-graph
    [label]="'Upload (Kbps)' | translate"
    [series]="h.upKbps"
    [minSpan]="64"></andor-stats-graph>
</div>

@if (pps) {
  <div class="packets">
    <span>{{ 'Packets' | translate }}</span>
    <span>↓ {{ pps.down }} /s · ↑ {{ pps.up }} /s</span>
  </div>
}

<h4 class="section-title">{{ 'Video Streams' | translate }}</h4>
<ul class="streams">
  @for (stream of streams(); track stream.key) {
    <li>
      <button type="button" class="stream" (click)="openStats(stream.userId, stream.kind)">
        <span class="dot" [class]="'dot--' + stream.severity"></span>
        <span class="who">
          {{ stream.isSelf ? ('You' | translate) : stream.name }}
          <small>
            {{ (stream.kind === 'screen' ? 'Screen' : 'Camera') | translate }}
            @if (stream.isSelf) {
              ↑
            }
          </small>
        </span>
        <span class="state">
          {{ stream.state ? (stream.state | translate) : stream.details }}
        </span>
        <fa-icon class="chevron" [icon]="faChevronRight"></fa-icon>
      </button>
    </li>
  } @empty {
    <li class="empty">{{ 'No active video streams' | translate }}</li>
  }
</ul>
